import type { BannerFilter, BannersFromBackend } from './types';

import type { ServiceConfig } from '../../utils/create-http-api-service';
import { STRAPI_URL } from '../constants';
import { getStrapiQueryParams } from '../utils/query-params';
import { strapiServiceAdapter } from '../utils/strapi-service-adapter';
import { transformBanners } from './transform';

export const getBanners = (withPreview: boolean, filter?: BannerFilter) => (
  function getBannersService({ brandName, language, instance, region }: ServiceConfig) {
    type AdapterProps = { response: BannersFromBackend };

    const queryParams = getStrapiQueryParams({ brandName, language, region });
    filter && queryParams.set(`filters[${filter}]$eqi]`, 'true');
    queryParams.set('sort[0]', 'weight:desc');
    queryParams.set('sort[1]', 'createdAt:desc');
    queryParams.set('populate', 'image');
    queryParams.append('populate', 'document');
    withPreview && queryParams.set('publicationState', 'preview');

    const url = `${STRAPI_URL.BANNERS}?${queryParams.toString()}`;

    return strapiServiceAdapter<AdapterProps, ReturnType<typeof transformBanners>>(
      url,
      instance.get,
      { responseHandler: transformBanners },
    );
  }
);
